export default __webpack_public_path__ + "static/media/1-icon-gallery-view-focused.910ac64e.svg";